import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, findDomFromVNode, onBeforeUnmount } from 'intact-react';
import { position } from '../position';
import { noop, isObject, isFunction } from 'intact-shared';
import { isEqualObject } from '../utils';
export function usePosition() {
  var instance = useInstance();
  var positioned = {
    value: false
  };
  instance.watch('value', function (value) {
    if (value) {
      positioned.value = false;
    }
  });
  ['of', 'position'].forEach(function (item) {
    instance.watch(item, function (newValue, oldValue) {
      if (!instance.get('value') ||
      // return if object is the same
      isObject(newValue) && isObject(oldValue) &&
      // is not event object
      !(newValue instanceof Event) && isEqualObject(newValue, oldValue)) return;
      handle(noop);
    }, {
      presented: true,
      inited: true
    });
  });
  // watch container, it is not commonly used
  instance.watch('container', function (newValue, oldValue) {
    if (!instance.get('value') ||
    // return if function is the same. Not rigorous!
    isFunction(newValue) && isFunction(oldValue) && newValue.toString() === oldValue.toString()) return;
    handle(noop);
  }, {
    presented: true,
    inited: true
  });
  // if the dropdown is nested, we must show child after parent has positioned
  function p(ofElement, parentFeedback) {
    var feedback;
    var pos = instance.get('position');
    switch (pos) {
      case 'left':
        pos = {
          my: 'right-10 center',
          at: 'left center'
        };
        break;
      case 'bottom':
        pos = {
          my: 'center top+10',
          at: 'center bottom'
        };
        break;
      case 'right':
        pos = {
          my: 'left+10 center',
          at: 'right center'
        };
        break;
      case 'top':
        pos = {
          my: 'center bottom-10',
          at: 'center top'
        };
        break;
    }
    position(findDomFromVNode(instance.menuVNode, true), _extends({
      my: 'left top+8',
      at: 'left bottom',
      collision: instance.get('collison')
    }, pos, {
      of: ofElement,
      using: function using(_feedback) {
        feedback = _feedback;
      }
    }));
    positioned.value = true;
    instance.trigger('positioned', parentFeedback || feedback);
    return parentFeedback || feedback;
  }
  function handle(callback) {
    var _of = instance.get('of');
    if (_of === 'parent') {
      var parent = instance.dropdown;
      if (process.env.NODE_ENV !== 'production') {
        if (!parent) {
          throw new Error('The dropdown has not parent, so you can not use `parent` as `of`.');
        }
      }
      var ofElement = findDomFromVNode(parent.menuVNode, true);
      if (parent.positionHook.positioned.value) {
        callback(p(ofElement, null));
      } else {
        // wait the parent has positioned
        var fn = function fn(feedback) {
          parent.off('positioned', fn);
          // let the child menu has the same transtion with parent menu,
          // when them show together
          callback(p(ofElement, feedback));
        };
        parent.on('positioned', fn);
      }
    } else if (_of === 'self') {
      callback(p(findDomFromVNode(instance.$vNode, true), null));
    } else {
      callback(p(_of, null));
    }
  }
  return {
    handle: handle,
    positioned: positioned
  };
}
export function usePositionForDropdownMenu() {
  var instance = useInstance();
  /**
   * Meybe the DropdownMenu has changed by specified key
   * so, we must reset the positioned.value beforeUnmount
   * #956
   */
  onBeforeUnmount(function () {
    instance.dropdown.positionHook.positioned.value = false;
  });
}